var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 14.647V13.3136C11.3332 12.6064 11.0522 11.9281 10.5521 11.428C10.052 10.9279 9.37375 10.647 8.6665 10.647H3.33317C2.62593 10.647 1.94765 10.9279 1.44755 11.428C0.947456 11.9281 0.666504 12.6064 0.666504 13.3136V14.647M15.3332 14.647V13.3136C15.3327 12.7228 15.1361 12.1488 14.7741 11.6818C14.4121 11.2149 13.9053 10.8814 13.3332 10.7336M10.6665 2.73364C11.2401 2.88051 11.7485 3.21411 12.1116 3.68185C12.4747 4.14959 12.6717 4.72486 12.6717 5.31697C12.6717 5.90909 12.4747 6.48436 12.1116 6.9521C11.7485 7.41984 11.2401 7.75344 10.6665 7.90031M8.6665 5.31364C8.6665 6.7864 7.4726 7.98031 5.99984 7.98031C4.52708 7.98031 3.33317 6.7864 3.33317 5.31364C3.33317 3.84088 4.52708 2.64697 5.99984 2.64697C7.4726 2.64697 8.6665 3.84088 8.6665 5.31364Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.3d3bfb5968e6b3c859b20f1fb17a4966.svg";
export { ForwardRef as ReactComponent };